<nav class="navbar navbar-expand-lg navbar-light bg-light primary">
	<span class="navbar-brand"><img src="../../assets/images/nesten-logo.png" alt="" class="img-fluid" style="height: 40px;"></span>
	<span class="headerSpace"></span>
	<i class="fa fa-bars" aria-hidden="true" (click)="openDialog()" style="font-size: x-large; cursor:pointer;"></i>
</nav>
<div class="main-div py-5">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12">
                <h2 class="title">Receive</h2>
                <div class="form-holder">
                    <div>
                        <div>
                            <!-- <mat-form-field class="example-full-width">
                                <input class="primary" [(ngModel)]="seed" matInput placeholder="Seed Word">
                            </mat-form-field> -->
                            <h4 class="text-center text-white mt-4 font-weight-bold">Scan this QR code to receive</h4>

                        </div>
                        <ngx-qrcode [qrc-value]="seed" qrc-class="aclass mb-4 qrc-code-area text-center" qrc-errorCorrectionLevel="L">
                        </ngx-qrcode>
                        <div>
                            <!-- <mat-form-field class="example-full-width">
                                <input class="primary" [(ngModel)]="seed" matInput placeholder="Seed Word">
                            </mat-form-field> -->
                            <h4 class="text-center text-white mt-4 font-weight-bold" style="word-break: break-all">
                              Account : <span>{{this.helper.getAddress()}}</span>
                              <a (click)="showPopup()" class="ml-2 popup" [routerLink]="" ngxClipboard [cbContent]="this.helper.getAddress()">
                                <img src="../../assets/images/copy.png">
                                <span class="popuptext" id="myPopup">Copied!</span>
                              </a>

                            </h4>
                        </div>
                        <div class="row">
                            <div class="col-12 text-center">
                                <button mat-stroked-button class="primary solid-gradient-btn" (click)="route('dashboard')">Back</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
